import { defa } from 'defa-object';
import ClusterModel    from 'scripts/poppet/cluster-model';

/**
 * defa.models.IasZone
 * The DEFA IasZone model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	wiredalarm: '/wiredAlarmInput/iasZone?attrs=',
};

const IasZone = ClusterModel.extend( {
	url: function() {
		return api.linkcom + this.get('id') + api.wiredalarm + this.getAttributes();
	},
	
	onError: function (model, response, options) {
		let models = this._getModels();
		for (let index in models ) {
			models[index].trigger('error', model, response, options);
		}
	},
	
	_getModels: function() {
		let id = this.get('id');
		return [
			channel.request('followMainAlarms').get(id),
			channel.request('generalAlarmInputs').get(id),
		];
	},
	
});

export default IasZone;
